import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { ComponentsProvider, MODALS_NAMESPACE } from '@panneau/core/contexts';
import modalDialog from '@panneau/modal-dialog';
import modalUpload from '@panneau/modal-upload';
import modalConfirm from '@panneau/modal-confirm';
import modalForm from '@panneau/modal-form';
import modalResourceForm from '@panneau/modal-resource-form';
import modalResourceItems from '@panneau/modal-resource-items';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Confirm: modalConfirm,
    Dialog: modalDialog,
    Form: modalForm,
    ResourceForm: modalResourceForm,
    ResourceItems: modalResourceItems,
    Upload: modalUpload
});

var _excluded = ["components", "children"];
var propTypes = {
  components: PropTypes.object,
  // eslint-disable-line
  children: PropTypes.node
};
var defaultProps = {
  components: null,
  children: null
};
var ModalsProvider = function ModalsProvider(_ref) {
  var injectedComponents = _ref.components,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsProvider, Object.assign({
    namespace: MODALS_NAMESPACE,
    components: _objectSpread(_objectSpread({}, components), injectedComponents)
  }, props), children);
};
ModalsProvider.propTypes = propTypes;
ModalsProvider.defaultProps = defaultProps;

export { ModalsProvider as default };
